"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.aggregateTimeReportItems = aggregateTimeReportItems;
const time_entry_type_1 = require("../time-entries/time-entry-type");
function aggregateTimeReportItems(items) {
    return items.reduce((acc, { type, days, hours }) => {
        switch (type) {
            case time_entry_type_1.TimeEntryType.Work:
                acc.work.days += days;
                acc.work.hours += hours;
                break;
            case time_entry_type_1.TimeEntryType.Vacation:
                acc.vacation.days += days;
                acc.vacation.hours += hours;
                break;
            case time_entry_type_1.TimeEntryType.Sick:
            case time_entry_type_1.TimeEntryType.ChildSick:
            case time_entry_type_1.TimeEntryType.SickInKUG:
                acc.sick.days += days;
                acc.sick.hours += hours;
                break;
            case time_entry_type_1.TimeEntryType.HourAdjustment:
                acc.adjustments.days += days;
                acc.adjustments.hours += hours;
                break;
            case time_entry_type_1.TimeEntryType.CompDay:
                acc.comp.days += days;
                acc.comp.hours += hours;
                break;
        }
        return acc;
    }, {
        work: { days: 0, hours: 0 },
        vacation: { days: 0, hours: 0 },
        sick: { days: 0, hours: 0 },
        adjustments: { days: 0, hours: 0 },
        comp: { days: 0, hours: 0 },
    });
}
//# sourceMappingURL=time-report.util.js.map